import { lachs } from './single-dishes/lachs';
import { germknoedel } from './single-dishes/germknoedel';
import { dinkelAuflauf } from './single-dishes/dinkelAuflauf';
import { kaeserahmsuppe } from './single-dishes/kaeserahmsuppe';
import { ribeyeSteak } from './single-dishes/ribeyeSteak';
import { gemuesepasta } from './single-dishes/gemuesepasta';
import { gemueseWraps } from './single-dishes/gemueseWraps';
import { schweinenackenBurger } from './single-dishes/schweinenackenBurger';
import { haehnchenCrossis } from './single-dishes/haehnchenCrossis';
import { hirschragout } from './single-dishes/hirschragout';
import { vegetarischeSchupfnudeln } from './single-dishes/vegetarischeSchupfnudeln';
import { gemuesegyrosVegan } from './single-dishes/gemuesegyrosVegan';

export const dishes = {
	monday: [
		{...gemuesepasta},
		{...lachs},
		{...gemueseWraps},
		{...germknoedel},
		{...haehnchenCrossis},
	],
	tuesday: [
		{...ribeyeSteak},
		{...dinkelAuflauf},
		{...kaeserahmsuppe},
	],
	wednesday: [
		{...schweinenackenBurger},
		{...haehnchenCrossis},
		{...hirschragout},
	],
	thursday: [
		{...vegetarischeSchupfnudeln},
		{...gemuesegyrosVegan},
	],
	friday: [
		{...dinkelAuflauf},
		{...lachs},
		{...haehnchenCrossis},
		{...gemuesegyrosVegan},
	],
};


// WEBPACK FOOTER //
// ./src/dishes/dishes.js